module.exports = __webpack_public_path__ + "static/media/Rose Colored Glasses.ab9a83f4.jpg";